import React, { useState, useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Welcome from "./pages/Welcome";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Sidebar from "./components/Sidebar";
import LatestNews from "./components/LatestNews";
import Header from "./components/Header";
import { auth } from "./firebase";
import Feed from "./components/Feed";
import Profile from "./profile/Profile";
import Help from "./pages/Help";

function App() {
  const [user, setUser] = useState([]);

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser)
      } else {
        setUser(false)
      }
    })
  }, [])

  return (
    <div className="app">
      <Router>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/register">
            <Register />
          </Route>
          <Route path="/home">
            <Header user={user} />
            <div className="app__body">
              <Sidebar user={user} />
                <Feed user={user} />
              <LatestNews user={user} />
            </div>
          </Route>
          <Route path="/:username/:uid">
            <Header user={user} />
            <Profile user={user} />
          </Route>
          <Route path="/help">
            <Help user={user}/>
          </Route>
          <Route path="/">
            <Welcome />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
